define(
    'services/service.documents',[
        "viewmodels/controller",
        "viewmodels/secured/explorer/context",
        "providers/dataprovider",
        "services/eventbroker",
        "services/config",
        "services/BusyTracker",
        "services/service.dialog",
        "i19n!i19n/strings",
        "extensions/kendo.extensions",
        "extensions/file.extensions"        
    ],

    // note: this service exists to allow abstraction and re-use so that the mocks can use it for creating the grid.
    // some of it could be pushed into a knockout custom binding but I tend to use ko bindings when it's used more than once.
    function(shell, ctx, dataProvider, eventBroker, config, BusyTracker, dialogService, i19n, kendoExt, fileExt) {
        var busyTracker = new BusyTracker();
        var _gridPageSize = 120;//24
        
        var vm = {
            busyTracker: busyTracker,
            dataCompleteCallback: function () { },

            getLibraryDocumentsConfig: getLibraryDocumentsConfig,
            getLibraryDocumentsShowAllConfig: getLibraryDocumentsShowAllConfig,
            getLibraryDocumentsShowDeletedConfig: getLibraryDocumentsShowDeletedConfig,
            getRecentDocumentsConfig: getRecentDocumentsConfig,
            getSearchedDocumentsConfig: getSearchedDocumentsConfig,
            getFlaggedDocumentsConfig: getFlaggedDocumentsConfig,
            getMyCheckedOutDocumentsConfig: getMyCheckedOutDocumentsConfig,
            getAllCheckedOutDocumentsConfig: getAllCheckedOutDocumentsConfig,
            getFavouriteDocumentsConfig: getFavouriteDocumentsConfig,
            getDeletedDocumentsConfig: getDeletedDocumentsConfig,
            getAllDeletedDocumentsConfig: getAllDeletedDocumentsConfig,

            //flagDocument: markDocument("flag"),
            //unflagDocument: markDocument("unflag"),
            //favouriteDocument: markDocument("favourite"),
            //unfavouriteDocument: markDocument("unfavourite"),

            actions: {
                //#region Actions 
                canShare: dataProvider.documents.actions.canShare,
                canDownload: dataProvider.documents.actions.canDownload,
                canSaveNewVersion: dataProvider.documents.actions.canSaveNewVersion,
                canCopyDocuments: dataProvider.documents.actions.canCopyDocuments,
                canMoveDocuments: dataProvider.documents.actions.canMoveDocuments,
                canExportDocuments: dataProvider.documents.actions.canCopyDocuments,
                canReplaceFile: dataProvider.documents.actions.canReplaceFile,
                canModifyField: dataProvider.documents.actions.canModifyField,
                canCheckout: dataProvider.documents.actions.canCheckout,
                canCheckin: dataProvider.documents.actions.canCheckin,
                canCancelCheckout: dataProvider.documents.actions.canCancelCheckout,
                canDelete: dataProvider.documents.actions.canDelete,
                canUndelete: dataProvider.documents.actions.canUndelete,
                canPurgeDeleted: dataProvider.documents.actions.canPurgeDeleted,

                copyDocuments: dataProvider.documents.actions.copyDocuments,
                copyDocumentsTemplate: dataProvider.documents.actions.copyDocumentsTemplate,
                moveDocuments: dataProvider.documents.actions.moveDocuments,
                exportDocumentsXLS: exportDocumentsXLS,
                exportListCSV: exportListCSV,
                importListCSV: importListCSV,
                deleteDocuments: dataProvider.documents.actions.deleteDocuments,
                undeleteDocuments: dataProvider.documents.actions.undeleteDocuments,
                purgedeletedDocuments: dataProvider.documents.actions.purgedeletedDocuments,
                modifyFieldDocuments: dataProvider.documents.actions.modifyFieldDocuments,
                cancelCheckOutDocuments: dataProvider.documents.actions.cancelCheckOutDocuments,
                checkoutDocuments: dataProvider.documents.actions.checkoutDocuments,

                getShareWithItems: dataProvider.documents.actions.getShareWithItems,
                shareDocuments: dataProvider.documents.actions.shareDocuments,
                getSharedMessage: dataProvider.documents.actions.getSharedMessage
                //#endregion
            },

            helpers: {
                getKendoModelFields: getKendoModelFields,
                getGridOptions: getGridOptions,
                getCreateResultsGridFn: getCreateResultsGridFn
            }
        };
       
        function getLibraryDocumentsConfig(libraryId) {            
            return $.Deferred(function (deferred) {
                dataProvider.documents
                .getLibraryDocumentSchema(libraryId)
                .done(function (result, statusCode) {
                    var data = {};

                    //normalizeColumns(result.columns);

                    data.createResultsGrid
                    = getCreateResultsGridFn(
                        getGridOptions(result.columns),
                        getDataSourceFn(function () { return getUrl("documents/folders/" + data.folderId); }, getKendoModelFields(result.columns))
                    );

                    deferred.resolve(data, statusCode);                           
                })
                .fail(function(result, statusCode) {
                    deferred.reject(result, statusCode);
                });
            }).promise();
        }
        function getLibraryDocumentsShowDeletedConfig(libraryId, folderId) {
            return $.Deferred(function (deferred) {
                dataProvider.documents
                .getLibraryDocumentSchema(libraryId)
                .done(function (result, statusCode) {
                    var data = {};

                    normalizeColumns(result.columns);

                    data.createResultsGrid
                    = getCreateResultsGridFn(
                        getGridOptions(result.columns),
                        getDataSourceFn(function () { return getUrl("documents/folders/admindeleted/" + folderId + "/showall/"); }, getKendoModelFields(result.columns)),
                        -1
                    );

                    deferred.resolve(data, statusCode);
                })
                .fail(function (result, statusCode) {
                    deferred.reject(result, statusCode);
                });
            }).promise();
        }
        function getLibraryDocumentsShowAllConfig(libraryId, folderId) {
            return $.Deferred(function (deferred) {
                dataProvider.documents
                .getLibraryDocumentSchema(libraryId)
                .done(function (result, statusCode) {
                    var data = {};

                    //normalizeColumns(result.columns);

                    data.createResultsGrid
                    = getCreateResultsGridFn(
                        getGridOptions(result.columns),
                        getDataSourceFn(function () { return getUrl("documents/folders/" + folderId + "/showall/"); }, getKendoModelFields(result.columns))
                    );

                    deferred.resolve(data, statusCode);
                })
                .fail(function (result, statusCode) {
                    deferred.reject(result, statusCode);
                });
            }).promise();
        }
        function getSearchedDocumentsConfig(query) {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), query);
        }
        function getRecentDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/recent");
        }
        function getFlaggedDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/flagged");
        }
        function getMyCheckedOutDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/checkedout");
        }
        function getAllCheckedOutDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/admin/checkedout");
        }
        function getFavouriteDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/favourite");
        }
        function getDeletedDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/deleted/my", 0);
        }
        function getAllDeletedDocumentsConfig() {
            return getDocuments(dataProvider.documents.getDocumentDefaultSchema(), "documents/deleted/all", 0);
        }

        function exportDocumentsXLS(rows, name) {
            var filename = name + ".xlsx";
            var creator = ''; //vm.session.users().displayName;

            var workbook = new kendo.ooxml.Workbook({
                creator: creator,
                sheets: [{
                    rows: rows
                }]
            });
            
            kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: filename
            });
        }
        function exportListCSV(listId) {
            require(["services/config"], function (config) {
                window.location = config.webApiUrl + "lists/export/instancebasic/" + window.fileplan.instanceCode + "/" + listId;
            });
        }
        function importListCSV(listId, file, done, fail) {
            shell.isBusy(true);

            dataProvider.lists
            .getImportList({ listId: listId, file: file })
            .done(function (data) {
                done();
            })
            .fail(function (e) {
                console.error(e);
                fail(e);
            })
            .always(function () {
                shell.isBusy(false);
            });
        }

        return vm;

        function getDocuments(schemaPromise, documentsUrl, showActionMenu) {
            return $.Deferred(function (deferred) {
                schemaPromise
                .done(function (result, statusCode) {
                    var data = {};

                    //normalizeColumns(result.columns);
                    
                    data.createResultsGrid
                    = getCreateResultsGridFn(
                        getGridOptions(result.columns),
                        getDataSourceFn( function () { return getUrl(documentsUrl); }, getKendoModelFields(result.columns)),
                        showActionMenu
                    );

                    deferred.resolve(data, statusCode);
                })
                .fail(function (result, statusCode) {
                    deferred.reject(result, statusCode);
                });

            }).promise();
        }
        
        //same as in results.html.js
        function getDocumentInfo(dataItem) {
            var _path = !ctx.current || !ctx.current.folder || !ctx.current.library || !ctx.current.library.list
                        ? ""
                        : dataItem.library + (ctx.current.folder.listId ? '/' + ctx.current.library.list.active.selectedRow().label : "");

            return {
                documentId: dataItem.documentId,
                libraryId: dataItem.libraryId,
                folderId: dataItem.folderId,
                docIdVersionId: dataItem.docIdVersionId,
                docIdVersion: dataItem.docIdVersion,
                applicationType: dataItem.applicationType,
                docDate: dataItem.docDate,
                isFavourite: dataItem.isFavourite,
                isFlagged: dataItem.isFlagged,
                accessControlRoleId: dataItem.accessControlRoleId,
                title: dataItem.title,
                extension: dataItem.extension,
                _path: _path
            };
        }
        //function markDocument(action) {
        //    return function (documentId) {
        //        var promise = dataProvider.documents[action + "Document"](documentId);

        //        busyTracker.add(promise);

        //        return promise;
        //    };
        //}
        
        function getCreateResultsGridFn(options, dataSourceFn, showActionMenu) {
            return function ($domElement, viewModel) {
                options.viewModel = viewModel;
                options.autoBind = false; //added

                var resultsGrid = $domElement.kendoGrid(options).data("kendoGrid");
                
                var sam = showActionMenu == undefined ? 1 : showActionMenu;

                kendoExt.grid.init({
                    isShowActionMenu: sam == 1 ? true: false,
                    grid: $domElement,
                    onSelect: function (id) {
                        setGridRow(resultsGrid.dataSource.get(id));
                    }
                });

                resultsGrid.options.viewModel.isDeleted = sam == -1 ? true: false;

                busyTracker.canProceed().done(function () {
                    resultsGrid.setDataSource(dataSourceFn());
                    resultsGrid.dataSource.read(); //added

                    resultsGrid.thead.kendoTooltip({
                        filter: 'th:not(th[data-title^=" "])',
                        content: function (e) {                            
                            var target = e.target; // element for which the tooltip is shown
                            var title = $(target).attr("data-title");

                            return title;
                        }
                    });
                });

                //#region row
                resultsGrid.table.off("dblclick", "tr", "**");
                resultsGrid.table.on("dblclick", "tr", toggleDblClick);

                resultsGrid.table.off("click", "tr", "**");
                resultsGrid.table.on("click", "tr", toggleSelect);
                resultsGrid.table.off("click", "#checkbox-action-results-grid:checkbox", "**");
                resultsGrid.table.on("click", "#checkbox-action-results-grid:checkbox", toggleCheck);
                resultsGrid.table.off("click", "i.favourite", "**");
                resultsGrid.table.on("click", "i.favourite", toggleFavorite);
                resultsGrid.table.off("mousedown", "i.favourite", "**");
                resultsGrid.table.on("mousedown", "i.favourite", function (e) { e.stopPropagation(); });
                resultsGrid.table.off("click", "i.flag", "**");
                resultsGrid.table.on("click", "i.flag", toggleFlag);
                resultsGrid.table.off("mousedown", "i.flag", "**");
                resultsGrid.table.on("mousedown", "i.flag", function (e) { e.stopPropagation();});
                //#endregion

                //#region toggle action header
                $("#results-grid-header-action-toggle").on("click", function (e) {                    
                    setTimeout(function () {
                        //var a = $("#results-grid-header-action-dropdown > a")[0];
                        //$(a).trigger("click");           

                        promptServerSelection(function () {                            
                            resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);
                           
                            vm.dataCompleteCallback = function (status) {
                                updateViewItems("all");
                            };

                        }, function () {
                            updateViewItems("all");
                        });
                    }, 1);
                });
                $("#results-grid-header-action-toggle1").on("click", function (e) {
                    setTimeout(function () {
                        var a = $("#results-grid-header-action-dropdown > a")[0];

                        $(a).trigger("click");
                    }, 1);
                });
                //#endregion

                //#region action header commands
                $('#results-grid-header-action-dropdown-all').on("click", function (e) {
                    promptServerSelection(function () {
                        resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);

                        vm.dataCompleteCallback = function () {
                            updateViewItems("all");
                        };

                    }, function () {
                        updateViewItems("all");
                    });
                });
                $('#results-grid-header-action-dropdown-none').on("click", function (e) {
                    promptServerSelection(function () {
                        resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);

                        vm.dataCompleteCallback = function () {
                            updateViewItems("none");
                        };

                    }, function () {
                        updateViewItems("none");
                    });

                    
                });
                $('#results-grid-header-action-dropdown-flagged').on("click", function (e) {
                    promptServerSelection(function () {
                        resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);

                        vm.dataCompleteCallback = function () {
                            updateViewItems("flagged");
                        };

                    }, function () {
                        updateViewItems("flagged");
                    });
                });
                $('#results-grid-header-action-dropdown-unflagged').on("click", function (e) {
                    promptServerSelection(function () {
                        resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);

                        vm.dataCompleteCallback = function () {
                            updateViewItems("unflagged");
                        };

                    }, function () {
                        updateViewItems("unflagged");
                    });
                });
                $('#results-grid-header-action-dropdown-favourited').on("click", function (e) {
                    promptServerSelection(function () {
                        resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);

                        vm.dataCompleteCallback = function () {
                            updateViewItems("favourited");
                        };

                    }, function () {
                        updateViewItems("favourited");
                    });
                });
                $('#results-grid-header-action-dropdown-unfavourited').on("click", function (e) {
                    promptServerSelection(function () {
                        resultsGrid.dataSource.pageSize(resultsGrid.options.viewModel.resultCount() + _gridPageSize);

                        vm.dataCompleteCallback = function () {
                            updateViewItems("unfavourited");
                        };

                    }, function () {
                        updateViewItems("unfavourited");
                    });
                });

                function updateViewItems(field) {
                    //if (field == "all") {
                    //    if (resultsGrid.tbody.find(":checkbox:not(:checked)").length == 0) {
                    //        return;
                    //    }
                    //}
                    var dataItems = resultsGrid.dataSource.data();                    
                    
                    //shell.isBusy(true);

                    var isCheck = false;

                    if (field == "all")
                        isCheck = true;
                    if (field == "none")
                        isCheck = false;
                    
                    for (var i = 0; i < dataItems.length; i++) {
                        if (field == "flagged")
                            isCheck = dataItems[i].isFlagged;
                        if (field == "unflagged")
                            isCheck = !dataItems[i].isFlagged;
                        if (field == "favourited")
                            isCheck = dataItems[i].isFavourite;
                        if (field == "unfavourited")
                            isCheck = !dataItems[i].isFavourite;

                        if (dataItems[i].checked != isCheck) {
                            dataItems[i].checked = isCheck;
                            //dataItems[i].set("checked", isCheck);

                            resultsGrid.tbody.find('tr[data-uid="' + dataItems[i].uid + '"] input:checkbox[class="checkbox-action-results-grid"]').prop("checked", isCheck);

                            ctx.onDocumentChecked({ document: getDocumentInfo(dataItems[i]), isChecked: isCheck });
                        }
                    }

                    //shell.isBusy(false);

                    //#region commented
                    //if (field == "favourited") {
                    //    resultsGrid.tbody.find("tr > td").find(":checkbox", ".results-grid-data-action").prop("checked", false);
                    //    resultsGrid.tbody.find("tr > td:has(i.fa-star)").find(":checkbox", ".results-grid-data-action").prop("checked", true);
                    //}
                    //if (field == "unfavourited") {
                    //    resultsGrid.tbody.find("tr > td").find(":checkbox", ".results-grid-data-action").prop("checked", false);
                    //    resultsGrid.tbody.find("tr > td:has(i.fa-star-o)").find(":checkbox", ".results-grid-data-action").prop("checked", true);
                    //}

                    //if (field == "flagged") {
                    //    resultsGrid.tbody.find("tr > td").find(":checkbox", ".results-grid-data-action").prop("checked", false);
                    //    resultsGrid.tbody.find("tr > td:has(i.fa-flag)").find(":checkbox", ".results-grid-data-action").prop("checked", true);
                    //}
                    //if (field == "unflagged") {
                    //    resultsGrid.tbody.find("tr > td").find(":checkbox", ".results-grid-data-action").prop("checked", false);
                    //    resultsGrid.tbody.find("tr > td:has(i.fa-flag-o)").find(":checkbox", ".results-grid-data-action").prop("checked", true);
                    //}
                    
                    //if (field == "all")
                    //    resultsGrid.tbody.find("tr > td").find(":checkbox", ".results-grid-data-action").prop("checked", true);
                    //if (field == "none")
                    //    resultsGrid.tbody.find("tr > td").find(":checkbox", ".results-grid-data-action").prop("checked", false);
                    
                    //console.warn((new Date()).getSeconds());
                    //#endregion

                }
                function promptServerSelection(yes, no) {
                    var size = resultsGrid.options.viewModel.resultCount();

                    if (size > resultsGrid.dataSource.pageSize()) {
                        if (size < 100) {
                            yes();
                        } else {
                            //#region option
                            var options = {
                                ok: {
                                    label: i19n.to.continue,
                                    message: i19n.to.happytowaitcontinuewithselection
                                },
                                cancel: {
                                    label: i19n.to.cancel,
                                    message: i19n.to.onlyselectthedocumentscurrentlydisplayed
                                }
                            };
                            //#endregion

                            var promise = dialogService.showMessageBox(i19n.to.selectdocuments, i19n.to.thisoperationcouldtakeafewminutestocomplete, _.toArray(options));

                            promise.then(function (result) {
                                if (result.label.toLowerCase() == i19n.to.continue.toLowerCase()) {
                                    yes();
                                } else {
                                    no();
                                }
                            });
                        }
                    } else {
                        no();
                    }
                }
                //#endregion

                //#region commented favourite/flag
                //$('#results-header-favorite').unbind('click');
                //$('#results-header-favorite').click(function (e) {
                //    var dataItems = resultsGrid.dataSource.view();
                //    var isChecked = $('#results-header-favorite').hasClass("fa-star-o");

                //    if (isChecked)
                //        $('#results-header-favorite').removeClass("fa-star-o").addClass("fa-star");
                //    else
                //        $('#results-header-favorite').removeClass("fa-star").addClass("fa-star-o");

                //    for (var i = 0; i < dataItems.length; i++) {
                //        dataItems[i].isFavourite = isChecked;

                //        var $row = resultsGrid.tbody.find("tr[data-uid='" + dataItems[i].uid + "']");

                //        if (isChecked)
                //            $row.find(".fa-star-o", ".results-grid-data-action").removeClass("fa-star-o").addClass("fa-star");
                //        else
                //            $row.find(".fa-star", ".results-grid-data-action").removeClass("fa-star").addClass("fa-star-o");

                //        // we really need a batch update.. in order to trap when database is completed updating. then reload
                //        ctx.onDocumentFavorited({ document: dataItems[i], isChecked: isChecked });
                //    }
                //});
                //$('#results-header-flag').unbind('click');
                //$('#results-header-flag').click(function (e) {
                //    var dataItems = resultsGrid.dataSource.view();
                //    var isChecked = $('#results-header-flag').hasClass("fa-flag-o");

                //    if (isChecked)
                //        $('#results-header-flag').removeClass("fa-flag-o").addClass("fa-flag");
                //    else
                //        $('#results-header-flag').removeClass("fa-flag").addClass("fa-flag-o");

                //    //var documentsFlag = [];
                //    //var documentsUnflag = [];

                //    //documentsService.actions
                //    //.flagDocuments(documents)
                //    //.done(function () {
                //    //})
                //    //.fail(function (e) {
                //    //    e.stopPropagation = true;
                //    //    self.errors(e.error);
                //    //    console.warn(e);
                //    //});
                    

                //    for (var i = 0; i < dataItems.length; i++) {
                //        dataItems[i].isFlagged = isChecked;

                //        var $row = resultsGrid.tbody.find("tr[data-uid='" + dataItems[i].uid + "']");

                //        if (isChecked)
                //            $row.find(".fa-flag-o", ".results-grid-data-action").removeClass("fa-flag-o").addClass("fa-flag");
                //        else
                //            $row.find(".fa-flag", ".results-grid-data-action").removeClass("fa-flag").addClass("fa-flag-o");

                //        // we really need a batch update.. in order to trap when database is completed updating. then reload
                //        ctx.onDocumentFlagged({ document: dataItems[i], isChecked: isChecked });
                //    }
                //});
                //#endregion

                // -FPA-2287
                sessionStorage.__mnuact__ = 0;

                return resultsGrid;

                function toggleDblClick(e) {
                    var $row = $(this);

                    var dataItem = resultsGrid.dataItem($row);

                    //console.warn(dataItem);

                    if (!dataItem) {
                        return;
                    }

                    require(['services/service.runapp'], function (fp) {
                        fp.run($("#protocol-container"), String.format("fpo://{0}", dataItem.docIdVersion));
                    });

                }
                function toggleSelect(e) {                    
                    if (sessionStorage.__mnuact__ == 1)
                        return;

                    var $row = $(this);

                    if ($row.find("#results-action-bar").length > 0) {

                        $row.removeClass("k-state-selected");
                        $row.prev().addClass("k-state-selected");

                        return;
                    }

                    var dataItem = resultsGrid.dataItem($row);

                    if (resultsGrid.table.find("tr.k-state-selected").length > 1) {
                        resultsGrid.table.find("tr.k-state-selected").removeClass("k-state-selected");
                        resultsGrid.table.find('tr[data-uid="' + dataItem.uid + '"]').addClass("k-state-selected");
                    }

                    if ($(e.target).attr('id') == 'checkbox-action-results-grid') {
                        var checks = resultsGrid.table.find('input[id="checkbox-action-results-grid"]:checked').length;
                        
                        if (checks == 1) {                            
                            if (dataItem.checked) { /*if($(e.target).is(':checked'))*/
                                if (resultsGrid.table.find("tr.k-state-selected").length > 0) {
                                    resultsGrid.table.find("tr.k-state-selected").removeClass("k-state-selected");
                                }

                                resultsGrid.table.find('tr[data-uid="' + dataItem.uid + '"]').addClass("k-state-selected");                                

                                setGridRow(dataItem);
                            }
                        }
                    } else {
                        //setGridRow(dataItem);
                    }
              
                    var badge = $(e.target);
                    if (badge.hasClass('badge')) {
                        if (dataItem.documentClass == "2" && !resultsGrid.options.viewModel.filterByDocId) {
                            var id = dataItem.docId;
                            
                            if (!id) {
                                id = dataItem.docIdVersionId + '-';
                                id = id.split('-')[0] + '-';
                                
                                eventBroker.trigger(vm, config.events.explorer.results.filterby, { type: 'field', field: 'docIdVersionId', value: id, operator: 'contains' });
                                resultsGrid.options.viewModel.filterByDocId = true;
                            } else {
                                eventBroker.trigger(vm, config.events.explorer.results.filterby, { type: 'field', field: 'docId', value: id });
                                resultsGrid.options.viewModel.filterByDocId = true;
                            }
                        } else {
                            if(!!resultsGrid.options.viewModel.filterByDocId)
                                eventBroker.trigger(vm, config.events.explorer.results.filterby, { type: 'default' });
                            resultsGrid.options.viewModel.filterByDocId = false;
                        }
                    }
                }
                function toggleCheck(e) {
                    e.stopPropagation();

                    var $row = $(this).closest("tr");
                    //var dataItem = resultsGrid.dataItem($row);
                    var dataItem = resultsGrid.dataSource.getByUid($row.attr("data-uid"));

                    dataItem.checked = this.checked;

                    ctx.onDocumentChecked({ document: dataItem, isChecked: this.checked });

                    var checks = resultsGrid.table.find('input[id="checkbox-action-results-grid"]:checked').length;
                    
                    if (checks == 0 && resultsGrid.table.find("tr.k-state-selected").length > 0) {
                        //resultsGrid.table.find("tr.k-state-selected").removeClass("k-state-selected");
                    }
                    if (checks == 1 && resultsGrid.table.find("tr.k-state-selected").length == 0) {
                        resultsGrid.select($row);
                        
                        setGridRow(dataItem);
                    }
                }
                function toggleFavorite(e) {
                    e.stopPropagation();

                    var $icon = $(this);
                    var $row = $icon.closest("tr");
                    //var dataItem = resultsGrid.dataItem($row);
                    var dataItem = resultsGrid.dataSource.getByUid($row.attr("data-uid"));
                    var isChecked = $icon.hasClass("fa-star-o");                                       
                    
                    dataItem.isFavourite = isChecked;

                    //ctx.onDocumentFavorited({ document: dataItem, isChecked: isChecked });
                    
                    if (isChecked) {
                        dataProvider.documents["favouriteDocument"](dataItem.documentId)
                        .done(function () {
                            $icon.removeClass("fa-star-o").addClass("fa-star");
                        });                        
                    } else {
                        dataProvider.documents["unfavouriteDocument"](dataItem.documentId)
                        .done(function () {
                            $icon.removeClass("fa-star").addClass("fa-star-o");
                        });
                    }

                    // do not remove item in grid when unfavorited as per james
                    //require(["viewmodels/secured/explorer/navigation/menu"], function (menu) {
                    //    if (menu.currentItem().id == 'favorite') {
                    //        resultsGrid.removeRow($row);
                    //    }
                    //});                    
                }
                function toggleFlag(e) {
                    e.stopPropagation();

                    var $icon = $(this);
                    var $row = $icon.closest("tr");
                    //var dataItem = resultsGrid.dataItem($row);
                    var dataItem = resultsGrid.dataSource.getByUid($row.attr("data-uid"));
                    var isChecked = $icon.hasClass("fa-flag-o");
                    
                    dataItem.isFlagged = isChecked;

                    ctx.onDocumentFlagged({ document: dataItem, isChecked: isChecked });

                    if (isChecked) {
                        dataProvider.documents["flagDocument"](dataItem.documentId)
                        .done(function () {
                            $icon.removeClass("fa-flag-o").addClass("fa-flag");
                        });
                    } else {
                        dataProvider.documents["unflagDocument"](dataItem.documentId)
                        .done(function () {
                            $icon.removeClass("fa-flag").addClass("fa-flag-o");
                        });
                    }

                    // do not remove item in grid when unflagged as per james
                    //require(["viewmodels/secured/explorer/navigation/menu"], function (menu) {
                    //    if (menu.currentItem().id == 'flagged') {
                    //        resultsGrid.removeRow($row);
                    //    }
                    //});
                }

                function setGridRow(dataItem) {
                    if (!dataItem) {
                        return;
                    }

                    var docActions = dataProvider.accessControl.documents.actions;

                    resultsGrid.options.viewModel.resultTitle = dataItem.title;
                    resultsGrid.options.viewModel.resultExtension = dataItem.extension;
                    //resultsGrid.options.viewModel.documentSelected(true);
                    resultsGrid.options.viewModel.actions.download(String.format("{0}documents/instancecontent/{1}/{2}", config.webApiUrl, config.instanceCode, dataItem.documentId));
                    
                    resultsGrid.options.viewModel.actions.openc(String.format("fpo://{0}", dataItem.docIdVersion));
                    resultsGrid.options.viewModel.actions.openr(String.format("fpr://{0}", dataItem.docIdVersion));

                    // as per chris, same as read only
                    //resultsGrid.options.viewModel.actions.new((dataItem.accessControlRoleId == docActions.fullAccess) || (dataItem.accessControlRoleId == docActions.fullControl) ? String.format("fpn://{0}", dataItem.docIdVersion) : null);

                    resultsGrid.options.viewModel.actions.new(String.format("fpn://{0}", dataItem.docIdVersion));
                    
                    var doc = getDocumentInfo(dataItem);
                    
                    if (ctx.current.library) {
                        ctx.saveState(ctx.current.library.libraryId, ctx.current);

                        //#region state management
                        var state = ctx.loadState(ctx.current.library.libraryId);

                        ctx.current = {
                            library: state.library,
                            list: state.list,
                            listValue: state.listValue,
                            folder: state.folder,
                            document: dataItem
                        };

                        ctx.saveState(ctx.current.library.libraryId, ctx.current);
                        //#endregion

                        ctx.onDocument(ctx.current.document);
                    } else {
                        ctx.current.document = dataItem;
                        ctx.onDocument(doc);
                    }

                    //console.warn(dataItem);
                    //console.warn(doc);
                    //console.warn('---');

                    if (sessionStorage.__url_type && sessionStorage.__url_type != "") {
                        if (doc) {
                            sessionStorage.__url_documentId = doc.documentId;

                            if (ctx.current.listValue) {
                                sessionStorage.__url = window.location.origin + "/#explorer/library-list/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_listValueId + "/" + sessionStorage.__url_folderId + "/" + sessionStorage.__url_documentId;
                            } else {
                                if (sessionStorage.__url_libraryId && sessionStorage.__url_folderId && sessionStorage.__url_documentId) {
                                    sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_folderId + "/" + sessionStorage.__url_documentId;
                                } else {
                                    if (sessionStorage.__url_libraryId && sessionStorage.__url_folderId) {
                                        sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_folderId;
                                    } else {
                                        if (sessionStorage.__url_libraryId) {
                                            sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId;
                                        } else {
                                            sessionStorage.__url = window.location.origin + "/#explorer";
                                        }
                                    }
                                }
                            }
                        } else {
                            if (ctx.current.listValue) {
                                sessionStorage.__url = window.location.origin + "/#explorer/library-list/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_listValueId + "/" + sessionStorage.__url_folderId;
                            } else {
                                if (sessionStorage.__url_libraryId && sessionStorage.__url_folderId) {
                                    sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_folderId;
                                } else {
                                    if (sessionStorage.__url_libraryId) {
                                        sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId;
                                    } else {
                                        sessionStorage.__url = window.location.origin + "/#explorer";
                                    }
                                }
                            }
                        }

                        window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
                    }

                }
            };
        }
        function getKendoModelFields(columns) {
            var model = {};
            _.each(columns, function (column) {                
                model[column.field] = { type: column.type || "string" };
            });

            // add this one on the fly.
            model.openUrl = { type: "string" };
            model.checked = { type: "boolean" };

            return model;
        }
        function getDataSourceFn(urlFn, fields) {
            // http ://www.kendoui.com/forums/kendo-ui-complete-for-asp-net-mvc/grid/missing-grid-options-when-using-attributes.aspx
            return function () {
                return new kendo.data.DataSource({
                    type: "aspnetmvc-ajax",
                    transport: {
                        read: {
                            type: "GET",
                            dataType: "json",
                            url: urlFn, // a function that returns the url for retrieving the documents.
                            cache: true,
                            beforeSend: function (req) {
                                req.setRequestHeader('InstanceCode', config.instanceCode);                                
                            },
                            complete: function (data, status) {
                                if (status == 'success') {
                                    //console.warn(data.responseJSON.data);
                                    vm.dataCompleteCallback(status);   
                                }

                                if (status == "error") {
                                    vm.dataCompleteCallback(status);
                                }
                            },
                        },
                    },
                    sort: {
                        //field: "title",
                        //dir: "asc"
                        field: "statusLastModifiedDate",
                        dir: "desc"
                    },
                    requestStart: function (e) {
                        var type = e.type;

                        if (type == 'read') {
                            
                        }                        
                    },
                    requestEnd: function (e) {
                        var type = e.type;

                        if (type == 'read') {
                        }                        
                    },
                    schema: {
                        parse: function (result) {
                            mapTypedJsonIntoKendoAcceptableJson(result.data);

                            result.data = result.data;
                            result.AggregateResults = result.aggregateResults;
                            result.Errors = result.errors;

                            return result;
                        },
                        total: function (result) {
                            return result.total;
                        },
                        data: function (result) {
                            return result.data;
                        },
                        model: {
                            id: 'documentId',
                            fields: fields
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverGrouping: true,
                    serverAggregates: true,
                    pageSize: _gridPageSize
                });
            };
        }
        function getGridOptions(columns) {            
            columns = _.map(columns, function (itm) {
                itm.visible = !itm.hidden ? true : itm.hidden;
                itm.filterable = !itm.filterable ? true : itm.filterable;

                if (!itm.title || itm.title == "") {
                    itm.title = " ";
                }
                
                if (itm.field == "isReadOnly" || itm.field == "isPublished") {
                    itm.width = "90px"; // BECAUSE WEB API RETURNS 10px
                }

                return itm;
            });
            columns = _.where(columns, { hidden: false });
            
            //#region documentClass
            columns = _.map(columns, function (itm) {
                if (itm.field == "documentClass") {
                    itm.filterable = false;
                    itm.field = "documentClass";
                    itm.title = " ";
                    itm.type = "";
                    itm.template = kendo.template($("#results-grid-data-document-class-template").html());
                    itm.width = kendo.support.mobileOS ? 97 : 85;
                    itm.visible = true;
                }
                if (itm.field == "isPrivileged") {
                    itm.template = '<div class="results-grid-data-checkbox"><input type="checkbox" #= isPrivileged ? \'checked="checked"\' : "" # onclick="return false"/></div>';
                }
                if (itm.field == "isOkayToPublish") {
                    itm.template = '<div class="results-grid-data-checkbox"><input type="checkbox" #= isOkayToPublish ? \'checked="checked"\' : "" # onclick="return false"/></div>';
                }
                if (itm.field == "isDiscoverable") {
                    itm.template = '<div class="results-grid-data-checkbox"><input type="checkbox" #= isDiscoverable ? \'checked="checked"\' : "" # onclick="return false"/></div>';
                }
                if (itm.field == "isCurrentVersion") {
                    itm.template = '<div class="results-grid-data-checkbox"><input type="checkbox" #= isCurrentVersion ? \'checked="checked"\' : "" # onclick="return false"/></div>';
                }
                
                //if (itm.field == "extension") {
                //    itm.title = " ";
                //}

                if (itm.field == "status") {
                    itm.type = "";
                    itm.template = kendo.template($("#results-grid-data-status-template").html());
                }

                return itm;
            });

            //var c = _.find(columns, function (itm) { return itm.field == "documentClass"; });
            //if (c) {
            //    columns = _.without(columns, c);

            //    //c.template = kendo.template($("#results-grid-data-document-class-template").html());
            //    //c.width = 85;
            //    //c.title = "&nbsp;";
            //    //c.type = "";
            //    //columns.unshift(c);

            //    columns.unshift({
            //        filterable: false,
            //        field: "documentClass",
            //        title: "&nbsp;",
            //        type: "",
            //        template: kendo.template($("#results-grid-data-document-class-template").html()),
            //        width: kendo.support.mobileOS ? 97 : 85,
            //        visible: true
            //    });
            //}
            //#endregion

            //#region action
            var headerActionTemplate = kendo.template($("#results-grid-header-action-template").html());

            columns.unshift({
                    field: "checked",
                    title: " ",
                    filterable: false,
                    //headerTemplate: headerActionTemplate({ isFavourite: ctx.menu.currentItem().id == "favorite", isFlagged: ctx.menu.currentItem().id == "flagged" }),
                    headerTemplate: kendo.template($("#results-grid-header-action-template").html()),
                    template: kendo.template($("#results-grid-data-action-template").html()),
                    sortable: false,
                    width: kendo.support.mobileOS ? 97 : 70,
                    visible: true
            });
            //#endregion

            //#region icon 
            columns.unshift({
                field: "icon",
                title: " ",
                filterable: false,
                template: "<i class='#: icon # application-type'/>",
                width: 36,
                resizable: false,
                sortable: false,
                visible: true                
            });
            //#endregion            

            kendoExt.grid.addColumnTemplateFormatters(columns);

            //var rowTemplate = kendo.template($("#results-grid-data-row-template").html());
            
            return {
                //rowTemplate: rowTemplate,
                minGridWidth: "1024px",
                selectable: "single",
                navigatable: false,
                resizable: true,
                reorderable: true,
                sortable: true,
                scrollable: { virtual: true },
                columns: columns,
                filterable: {
                    extra: false,
                    operators: {
                        string: { contains: "Contains" }
                    }
                },
                columnReorder: function (e) {
                    var $cog = this.element.find(".k-grid-header").find(".fa-cog");
            
                    if (!$cog.hasClass("cog-blue")) {                        

                        $cog.removeClass("fa-cog");
                        $cog.addClass("fa-floppy-o");

                        var tooltip = $("#results-grid .k-grid-header").kendoTooltip({
                            filter: "i.fa-floppy-o",
                            position: "right",
                            autoHide: true,
                            content: function (e) {
                                return i19n.to.clicktosavecolumnorderforallusers;
                            },
                            show: function () {
                                $(this.popup.wrapper).css({
                                    top: $(this.popup.wrapper).position().top,
                                    left: $(this.popup.wrapper).position().left + 12
                                });
                            }
                        }).data("kendoTooltip");

                        tooltip.show();
                    }
                }
                //columnMenu: true,
                //columnMenuInit: function (e) {
                //    var menu = e.container.find(".k-menu").data("kendoMenu");
                //    var field = e.field;
                //    var grid = this;
                //    //$(e.container).find("ul").append('<li id="my-id" class="k-item k-state-default" role="menuitem"><span class="k-link"><b>Manual entry</b></span></li>');

                //    var item = e.container.find(".k-columns-item");

                //    item.find("span:contains('__action__')").remove();

                    
                //    menu.bind("select", function (e) {
                //        grid.resize();
                //        grid.refresh();
                //    });
                //}
            }
        }
        function mapTypedJsonIntoKendoAcceptableJson(items) {
            //var dd = new Date();
            //var _oid = dd.getHours() + '' + dd.getMinutes() + '' + dd.getSeconds();

            _.each(items, function (item) {
                item.actions = item.actions || {};
                //item.actions.open = getUrl("documents/" + item.documentId);
                item.actions.openr = getUrl("documents/" + item.documentId);
                item.actions.openc = getUrl("documents/" + item.documentId);
                item.icon = fileExt.getApplicationTypeIcon(item.applicationType);
                item.checked = false;

                //item._oid = _oid;
                item._oid = null;
                
                if (item.attachmentCount == null) {
                    item.attachmentCount = "0";
                }
                    
                if (item.aggregates) {
                    // kendo grid - aspnetmvc.min.js expects PascalCase - time to fudge.
                    item.AggregateFunctionsProjection = item.aggregateFunctionsProjection;
                    item.Aggregates = item.aggregates;
                    item.HasSubgroups = item.hasSubgroups;
                    item.ItemCount = item.itemCount;
                    item.Items = item.items;

                    if (item.hasSubgroups) {
                        mapTypedJsonIntoKendoAcceptableJson(item.items);
                    }

                    item.Key = item.key;
                    item.Member = item.member;                   
                    
                    delete item.key;
                    delete item.member;
                    delete item.aggregateFunctionsProjection;
                    delete item.aggregates;
                    delete item.hasSubgroups;
                    delete item.itemCount;
                    delete item.items;
                }
            });
        }
        function normalizeColumns(items) {
            //_.each(items, function (itm) {
            //    if (itm.field == "FiledIn") {
            //        itm.field = "filedIn";
            //    }
            //});

            items.push({
                encoded: false,
                field: "isFavourite",
                filterable: true,
                hidden: true,
                template: null,
                title: "Favourite",
                type: "boolean",
                visible: true,
                width: "0px"
            });

            items.push({
                encoded: false,
                field: "isFlagged",
                filterable: true,
                hidden: true,
                template: null,
                title: "Flagged",
                type: "boolean",
                visible: true,
                width: "0px"
            });
        }


        function getUrl(action) {
            return config.webApiUrl + action;
        }
    }
);
